module.exports = __webpack_public_path__ + "static/media/motor-spec-finder.7010470d.png";